// extracted by mini-css-extract-plugin
export default {"eventComponent":"Events_eventComponent__+j3UF","sectionOne":"Events_sectionOne__wsvL8"};